const items = ["Intentional Training", "Strength", "Rehab", "Move Better", "Mobility", "Recovery", "Performance", "Longevity"];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section className="bg-gold text-black overflow-hidden border-y border-black/20" data-testid="marquee-section" aria-hidden="true">
      <div className="marquee-track flex w-max py-4 md:py-5">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-display font-bold uppercase tracking-[0.1em] text-2xl md:text-4xl whitespace-nowrap">
                <span className="px-6 md:px-10">{item}</span>
                <span className="text-black/60 text-xl md:text-2xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
